import overArg from "./_overArg.js";
var nativeKeys = overArg(Object.keys, Object);
export {
  nativeKeys as default
};
//# sourceMappingURL=_nativeKeys.js.map
